import type {
  QBankStructureLevel,
  QBankStructureLevelItem,
  QBankStructureLevelItemWithLevel,
} from '../providers';

export function formatQBankStructureLevelItems(
  levelItems: QBankStructureLevelItem[],
  qBankStructureLevels: QBankStructureLevel[],
) {
  return levelItems
    .map((levelItem) => {
      const matchingQBankStructureLevel = qBankStructureLevels.find(
        (level) => level.id === levelItem.qBankStructureLevelId,
      );

      if (!matchingQBankStructureLevel) {
        return;
      }

      return {
        ...levelItem,
        parentLevelItemId: levelItem.parentLevelItemId ?? null,
        tagId: levelItem.tagId ?? null,
        tag: levelItem.tag ?? null,
        qBankStructureLevel: matchingQBankStructureLevel,
      } as QBankStructureLevelItemWithLevel;
    })
    .filter((levelItem) => levelItem !== undefined);
}
